import { Paper, Grid2 as Grid, Alert } from "@mui/material";
import React from "react";
import { useAppSelector } from "@store/hooks";

const name = "SuccessNotice";

const SuccessNotice: React.FC = () => {
    const squareCardString = useAppSelector(({ ui }) => ui.SquareCardString)

    return (
        (<Paper elevation={2} sx={{ padding: 2, paddingRight: 1 }}>
            <Grid
                size={{
                    xs: 12,
                    sm: 12
                }}>
                <Paper elevation={2} sx={{ padding: 2, marginLeft: -1 }}>
                    <Alert severity="success">{`SUCCESS... Secured with Square!`}</Alert>
                    <Alert severity="info" sx={{ mt: 2 }}>{squareCardString}</Alert>
                </Paper>
            </Grid>
        </Paper>)
    );
}

SuccessNotice.displayName = name;

export default React.memo(SuccessNotice);
